import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../utils/data-load-error/data-load-error";

export enum OrderCancelRequestErrorType {
  ORDER_CANCELLED = "ORDER_CANCELLED",
  ORDER_CANCEL_REQUESTED = "ORDER_CANCEL_REQUESTED",
  ORDER_FINISHED = "ORDER_FINISHED",
}

export type OrderCancelRequestOrderCancelledError = DataLoadError<
  OrderCancelRequestErrorType.ORDER_CANCELLED,
  {}
>;

export type OrderCancelRequestOrderCancelRequestedError = DataLoadError<
  OrderCancelRequestErrorType.ORDER_CANCEL_REQUESTED,
  {}
>;

export type OrderCancelRequestOrderFinishedError = DataLoadError<
  OrderCancelRequestErrorType.ORDER_FINISHED,
  {}
>;

type OrderCancelRequestError =
  | DataLoadDefaultErrors
  | OrderCancelRequestOrderCancelledError
  | OrderCancelRequestOrderCancelRequestedError
  | OrderCancelRequestOrderFinishedError;

export default OrderCancelRequestError;
